export class NumberKeyDictionary<T> {
	[key: number]: T;

	isEmpty() {
		return Object.keys(this).length === 0;
	}
}
